import type {
  CambioDeEstadoDeCuenta, RespuestaDetalleDeProfesional, RespuestaPanel, RespuestaProfesionalesAdministrados,
  RespuestaReclamoAdministrado, RespuestaReclamosAdministrados, RespuestaResenaModerada, RespuestaResenasModeradas,
  ResolucionDeVerificacion,
} from '@medchoice/shared';
import { buildQuery, request } from './client';

const BASE = '/administracion';

export const administracion = {
  panel: (semanas: number) => request<RespuestaPanel>(`${BASE}/panel${buildQuery({ semanas })}`).then((r) => r.panel),

  profesionales: () =>
    request<RespuestaProfesionalesAdministrados>(`${BASE}/profesionales`).then((r) => r.profesionales),
  profesional: (id: number) =>
    request<RespuestaDetalleDeProfesional>(`${BASE}/profesionales/${id}`).then((r) => r.profesional),
  verificar: (id: number, resolucion: ResolucionDeVerificacion) =>
    request<RespuestaDetalleDeProfesional>(`${BASE}/profesionales/${id}/verificacion`, { method: 'POST', body: resolucion })
      .then((r) => r.profesional),

  cambiarEstadoDeCuenta: (id: number, cambio: CambioDeEstadoDeCuenta) =>
    request<void>(`${BASE}/usuarios/${id}/estado`, { method: 'PATCH', body: cambio }),

  reclamos: () => request<RespuestaReclamosAdministrados>(`${BASE}/reclamos`).then((r) => r.reclamos),
  reclamo: (id: number) => request<RespuestaReclamoAdministrado>(`${BASE}/reclamos/${id}`).then((r) => r.reclamo),
  tomarReclamo: (id: number) =>
    request<RespuestaReclamoAdministrado>(`${BASE}/reclamos/${id}/proceso`, { method: 'POST' }).then((r) => r.reclamo),
  cerrarReclamo: (id: number, resolucion: string) =>
    request<RespuestaReclamoAdministrado>(`${BASE}/reclamos/${id}/cierre`, { method: 'POST', body: { resolucion } })
      .then((r) => r.reclamo),

  resenas: () => request<RespuestaResenasModeradas>(`${BASE}/resenas`).then((r) => r.resenas),
  moderarResena: (id: number, visible: boolean) =>
    request<RespuestaResenaModerada>(`${BASE}/resenas/${id}`, { method: 'PATCH', body: { visible } }).then((r) => r.resena),
};
